import {
  Alert,
  AlertTitle,
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import PageContainer from "src/components/container/PageContainer";

// components
import { LinkedIn } from "@mui/icons-material";
import {
  IconAlertTriangle,
  IconBolt,
  IconBuildingBank,
  IconCurrencyRupee,
  IconMail,
} from "@tabler/icons";
import axios from "axios";
import { Link } from "react-router-dom";
import { axiosInstance, baseURL } from "src/api/axios";
import { FacebookIcon, InstagramIcon, TelegramIcon } from "src/assets/Icons";
import CategoryBlock from "src/components/shared/CategoryBlock";
import MonthlyEarnings from "./components/MonthlyEarnings";
import RecentTransactions from "./components/RecentTransactions";
import ActiveLeads from "./components/TotalEarnings";
import Banner from "./components/carousel/Banner";
import Carousel from "./components/carousel/Carousel";

const UserDashboard = () => {
  const [user, setUser] = useState({});
  const [wallet, setWallet] = useState({});
  const [loaded, setLoaded] = useState(false);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  useMemo(() => {
    if (!loaded) {
      axiosInstance.get("/users").then((response) => {
        if ("status" in response && response.status === 200) {
          console.log(response.data);
          if (!response.data.isPhoneVerified) {
            alert(
              "Your OTP has not been verified, Please register again , or login from a different account"
            );
            localStorage.removeItem("token");
            localStorage.removeItem("store");
            window.location.href = "/auth/register";
          }

          setUser(response.data);
          setLoaded(true);
          if (response.data.wallet) {
            axiosInstance
              .get(
                `/users/wallet/${
                  response.data.wallet?.id || response.data.wallet
                }`
              )
              .then((wallet) => {
                if (wallet?.status === 200) {
                  console.log(wallet);
                  setWallet(wallet.data);
                }
              });
          }
        }
      });
    }
  }, []);

  const sendVerifyEmail = async () => {
    const email = JSON.parse(localStorage.getItem("store"));
    await axios
      .post(baseURL + "/auth/send-verification-email", {
        email: email?.user?.email || email?.email,
      })
      .then(() => {
        toast.success("Verification email Sent");
      })
      .catch((e) => {
        console.log(e);
        toast.error("Failed to send Email", { position: "bottom-center" });
      });
  };

  const facebookShare = "http://www.facebook.com/share.php?u=";
  const telegramShare = "https://telegram.me/share/url?url=";
  const xShare = `https://twitter.com/intent/post?url=`;
  const gmailShare = `mailto:?subject=${encodeURIComponent(
    "Create your own Account in few clicks"
  )}&body=`;
  const shareMessage = `Hello✋

*Do you want to earn Rs.1 Lakh or more💰 from online with 👌0 investment with EarnPati?*

Now you can refer📣 financial products like Bank Account, Demat Account, Credit Cards, Pay Later and more to your friends/family/network🤝 and earn upto ₹3000 commission per successful account opening✅ with EarnPati.

*Download EarnPati app today📲:* https://earnpati.page.link/ocNj

*#AbHarIndiansKamayega*
`;

  return (
    <PageContainer
      title="Dashboard | EarnPati"
      description="this is Earnpati User Dashboard"
      sx={{ maxWidth: { xs: "100vw", lg: "70vw" } }}
    >
      <Grid container spacing={1} sx={{ padding: "0 .5rem" }}>
        <Grid item xs={12} justifyContent={"center"} alignItems={"center"}>
          {lgDown && user && !user.isEmailVerified ? (
            <Box
              sx={{
                bgcolor: "#000",
                minHeight: { xs: "62px", sm: "auto" },

                color: "#fff",
                fontSize: "11px",
                px: 2,
                py: 1,
                width: "100vw",
                ml: -3,
              }}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"start"}
              >
                <Stack mr={1} ml={1.5}>
                  <IconMail color="#fff" width="35px" />
                </Stack>
                <Stack spacing={0.5}>
                  <Typography variant="h6" pt={0.5}>
                    Important!{" "}
                    <IconAlertTriangle
                      style={{
                        verticalAlign: "middle",
                        marginTop: "-5px",
                        color: "yellow",
                      }}
                    />
                  </Typography>
                  <Typography variant="p">
                    Please verify your{" "}
                    <Link
                      to="#"
                      onClick={sendVerifyEmail}
                      style={{ color: "#fff" }}
                    >
                      Email
                    </Link>{" "}
                    to get Leads and Payments updates
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          ) : null}
        </Grid>
        <Grid item xs={12} justifyContent={"center"} alignItems={"center"}>
          {lgDown && user && !("bankAccount" in user) ? (
            <Box
              sx={{
                bgcolor: "#F5F5F5",
                height: { sm: "70px", xs: "auto" },
                color: "#333",
                maxWidth: "250px",
                borderRadius: "30px",
                p: 2,
                m: 2,
                fontSize: "12px",
                margin: "1rem auto",
              }}
            >
              <Stack direction={"row"}>
                <Stack style={{ width: "20%" }}>
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#333",
                      borderRadius: "50%",
                    }}
                  >
                    <IconBuildingBank color="#fff" />
                  </div>
                </Stack>
                <Stack spacing={0.5} style={{ width: "80%" }}>
                  <Typography variant="h6">To Receive Payments</Typography>
                  <Typography variant="p">
                    Add your <Link to="/profile">Bank Account</Link> Details
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          ) : null}
        </Grid>
        <Grid container spacing={lgUp ? 1 : 1}>
          <Grid item xs={6} lg={6}>
            <ActiveLeads wallet={wallet} user={user} />
          </Grid>

          <Grid item xs={5} lg={6}>
            <MonthlyEarnings wallet={wallet} user={user} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {lgDown ? (
            <Alert
              variant="outlined"
              style={{ minHeight: "100px", overflow: "hidden" }}
              icon={
                <div
                  style={{
                    width: "35px",
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#000",
                    borderRadius: "50%",
                    alignSelf: "center",
                    py: 2,
                  }}
                  onClick={() =>
                    (window.location.href = "/dashboard/transactions")
                  }
                >
                  <IconBolt color="white" />
                </div>
              }
              sx={{
                width: "100%",
                minWidth: "92vw",
                ml: {
                  md: 0,
                  xs: "-.5rem",
                },
                opacity: 1,
                bgcolor: "#F1F8E9",
                minHeight: "64px",
                color: "#333",
              }}
            >
              <AlertTitle>
                <h3 style={{ margin: "5px 0" }}>Truly Same Day Payments</h3>
              </AlertTitle>
              <Typography style={{ fontSize: "12px" }}>
                All Pending Amount in{" "}
                <span style={{ fontWeight: 800 }}>Balance</span> Will be
                transferred by 11PM Today
              </Typography>
            </Alert>
          ) : null}
        </Grid>
        <Grid container>
          <Grid item xs={12} sx={{ mt: 1, mb: 2 }}>
            <Banner />
          </Grid>
          {lgDown ? (
            <Grid item xs={12}>
              <CategoryBlock
                title={
                  <Typography variant="h4" sx={{ paddingLeft: "10px" }}>
                    Sell and Earn{" "}
                    {
                      <span
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        <IconCurrencyRupee />
                      </span>
                    }
                    1 Lakh Per Month
                  </Typography>
                }
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sx={{ my: 2 }}>
            <Typography variant="h4" sx={{ mt: 1, mb: { sm: 0, xs: -2 } }}>
              Top Products to Sell
            </Typography>
            <Carousel filter={"top"} />
          </Grid>
          {lgDown ? (
            <Grid item width={"100%"}>
              <Stack
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                mb={4}
              >
                <Typography
                  sx={{ fontWeight: 700, textAlign: "center", mb: 4 }}
                >
                  Follow us to stay connected with EarnPati
                </Typography>
                <Stack direction={"row"} spacing={2}>
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://t.me/earnpatiapp"
                    >
                      <TelegramIcon />
                    </a>
                  </div>
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/profile.php?id=61553755900160"
                    >
                      <FacebookIcon />
                    </a>
                  </div>
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://instagram.com/earnpati?igshid=MzMyNGUyNmU2YQ"
                    >
                      <InstagramIcon />
                    </a>
                  </div>
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/earnpati"
                    >
                      <LinkedIn />
                    </a>
                  </div>
                </Stack>
              </Stack>
            </Grid>
          ) : null}
          {!lgDown ? (
            <Grid item xs={12} my={2}>
              <RecentTransactions transactions={wallet?.transactions} />
            </Grid>
          ) : null}
        </Grid>
      </Grid>
      <ToastContainer />
    </PageContainer>
  );
};

export default UserDashboard;
